export function formatCustomCheck(check) {
  return check.message;
}
